module.exports = "/_next/static/images/bg-dwp-xv-landing-cover-796a4c6bc052c361f70f4a063da9f64f.jpg";